import { createContext } from 'react';
import { useFiltersContext } from '../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_SAMU,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import config from '../../../../../../config/config';
import { getUserSession } from '../../../../../../util/core/Session';

export const APHChartsDataContext = createContext();

const APHChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const session = getUserSession();
    const profile = session?.user?.application_profile_id;
    const isAdm = profile === config.default_foreign_key.profiles.zellusAdmin;

    const filterParams = {
        ano: filters.ano?.value,
        ...(filters.mes?.value && { mes: filters.mes.value }),
        ...(isAdm && filters.cidade?.value && { city: filters.cidade.value })
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SAMU.APH_RESULTS,
            url: 'governanceroom/dashboardsamu/results/aph'
        },
        filterParams
    );

    const chartData = data
        ? {
              ocurrenceListByAPHType:
                  data?.ocurrenceListByAPHType ?? [],
              ocurrenceByAPHType:
                  data?.ocurrenceByAPHType ?? []
          }
        : {
              ocurrenceListByAPHType: [],
              ocurrenceByAPHType: []
          };

    return (
        <APHChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </APHChartsDataContext.Provider>
    );
};

export default APHChartsDataProvider;
